<div class="chat-room-input flex flex-col gap-2 items-end p-4 w-full">
  <div class="relative flex-grow w-full">

    <!-- 🧩 Suggestions dropdown above textarea -->
    <div *ngIf="showSuggestions"
      class="absolute bottom-full mb-2 bg-white border border-gray-200 rounded-lg shadow-md z-50 w-full max-h-48 overflow-auto"
      #suggestionsContainer>
      <div *ngFor="let item of suggestions; let i = index" (click)="selectSuggestion(item)"
        class="p-2 hover:bg-gray-100 cursor-pointer text-sm flex items-center justify-between"
        [class.bg-gray-100]="i === selectedSuggestionIndex" [attr.data-index]="i" #suggestionItem>
        <span *ngIf="tagType === 'user'">{{ '@' + (item.firstname) }} {{item.name}}</span>
        <span *ngIf="tagType === 'doc'">{{ '#' + item.title }}</span>
      </div>
    </div>

    <div class="relative w-full">
      <!-- Overlay coloré -->
      <div class="font-mono absolute inset-0 p-3 whitespace-pre-wrap break-words text-gray-900 pointer-events-none z-0 bg-[#fcfcff] overlay"
        [innerHTML]="highlightedMessage">
      </div>

      <!-- Textarea réelle -->
      <textarea #textareaRef pInputTextarea class="font-mono w-full p-3 rounded-lg resize-none relative z-10"
        [rows]="3" [autoResize]="true" placeholder="Tapez votre message..." [(ngModel)]="message"
        (input)="handleInput($event)" (keydown)="handleKeyDown($event)" [disabled]="loading || !currentRoom">
        </textarea>
    </div>

  </div>

  <div class="flex justify-between w-full items-center mt-2">
    <div class="priority-toggle flex items-center">
      <p-checkbox [(ngModel)]="isPriority" [binary]="true" inputId="priority" [disabled]="loading || !currentRoom">
      </p-checkbox>
      <label for="priority" class="ml-2 cursor-pointer select-none" [class.font-bold]="isPriority">
        Message prioritaire
        <i *ngIf="isPriority" class="pi pi-exclamation-circle ml-1 animate-pulse text-red-500"></i>
      </label>
    </div>

    <button pButton icon="pi pi-send" class="p-button-rounded" [class.p-button-danger]="isPriority"
      [disabled]="!message.trim() || loading || !currentRoom" [loading]="loading" pTooltip="Envoyer"
      tooltipPosition="top" (click)="sendMessage()">
    </button>
  </div>
</div>